import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GET } from '../../configs/api';
import { api } from '../../utils/constants';

export const fetchAccountingTabCounts = createAsyncThunk(
  'accountingCounts/fetchAccountingTabCounts',
  async (_, { rejectWithValue }) => {
    try {
      const { data, error, message, status } = await GET(api.getAccountingJobCounts);
      if (error || status === 403) {
        return rejectWithValue(message || 'Failed to fetch accounting counts');
      }
      return data?.counts ?? {};
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch accounting counts');
    }
  }
);

const initialState = {
  counts: {
    'ready-for-invoicing': 0,
    'not-qb-invoiced': 0,
    'not-sent-to-client': 0,
  },
  loading: false,
  error: null,
};

const accountingCountsSlice = createSlice({
  name: 'accountingCounts',
  initialState,
  reducers: {
    clearAccountingTabCounts: (state) => {
      state.counts = { ...initialState.counts };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountingTabCounts.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchAccountingTabCounts.fulfilled, (state, action) => {
        state.counts = {
          ...state.counts,
          ...action.payload,
        };
        state.error = null;
      })
      .addCase(fetchAccountingTabCounts.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearAccountingTabCounts } = accountingCountsSlice.actions;
export const getAccountingTabCounts = (state) => state.accountingCounts.counts;

export default accountingCountsSlice.reducer;
